module.exports = __webpack_public_path__ + "static/media/LN-course-blog.3d13528c.png";